<i18n src="../../locales/lang.json"></i18n>

<template>
  <div class="container-fluid p-0">

    <div class="card shadow-0 border-0" style="background-color:inherit">
      <div class="card-body skin light-bg text-center card-img-top" >
        
        <h6 class="font-weight-semibold mb-0 font-weight-bolder">{{name}}</h6>
       
      </div>

     
    </div>
  </div>
</template>

<script>
  let message = "";
  export default {
    name: "view-qrcode",
    components: {

    },
    props: {
      qrcodeId: {
        type: Number,
        default: -1
      },
    },
    data() {
      return {
        message: "",
        name: "",
        enabled: "",
        longitude: 0,
        lattitude: 0,
      };
    },
    methods: {
      async getQRCode(qrcodeId) {
        try {         
          this.$http.get('/api/QRCodes/v1/' + qrcodeId).then(async response => {
            var qrcode = response.data;
            this.name = qrcode.Name;
          });
        } catch (err) {
          alert('some error:' + err)
        }
      }
    },
    watch: {
      qrcodeId: function (newVal, oldVal) {
        if (newVal > 0) {
          this.getQRCode(newVal);
        }
      }
    },
    mounted() {
      if (this.qrcodeId > 0) {
        this.getQRCode(this.qrcodeId);
      }
    }
  };
</script>
<style scoped>
</style>




// WEBPACK FOOTER //
// src/components/qrcode/view-qrcode.vue